import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import CreatableLazySelect from '../../../../../../components/LazyLoadSelect/lazy-load-creatable';
import useApi from '../../../../../../hooks/useApi';

const AsyncCreatableSelectBox = props => {
  const {
    url,
    name,
    labelText,
    required,
    placeholder = 'Start Typing',
    onChange,
    onBlur,
    value,
    isValid,
  } = props;

  const api = useApi();

  const getOption = (query, offset) =>
    new Promise((resolve, reject) => {
      api.get(
        url,
        { query, offset },
        {
          handleError: response => reject(response),
          handleSuccess: data => resolve(data),
        }
      );
    });

  return (
    <div className="form__group form__group--compact">
      <CreatableLazySelect
        name={name}
        isMulti={false}
        value={value}
        isValid={isValid}
        label={labelText}
        labelStyles={{
          fontWeight: 'bold',
        }}
        required={required}
        placeholder={placeholder}
        getOption={getOption}
        onChange={onChange}
        onBlur={onBlur}
      />

      <ErrorMessage
        name={name}
        render={message => <div className="form__error">{message}</div>}
      />
    </div>
  );
};

const AsyncCreatableSelectBoxItem = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

AsyncCreatableSelectBox.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: AsyncCreatableSelectBoxItem,
  required: PropTypes.bool,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  isValid: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default AsyncCreatableSelectBox;
